/* eslint-disable */

/**File to declare all the app constants */

const COUNTRY_DICTIONARY = {
  India: [
    {
      city_name: "Delhi",
      rating: "8.5/10",
      description:
        "Delhi, India’s capital territory, is a massive metropolitan area in the country’s north. In Old Delhi, a neighborhood dating to the 1600s, stands the imposing Mughal-era Red Fort, a symbol of India, and the sprawling Jama Masjid mosque, whose courtyard accommodates 25,000 people.",
    },
    {
      city_name: "Lucknow",
      rating: "9.5/10",
      description:
        "Lucknow, is the capital of the state of Uttar Pradesh, a cultural hotspot in northern India for many centuries. Heritage, food, shopping whatever reason you travel for it has them all. Toward its center is Rumi Darwaza, a Mughal gateway. Nearby, the 18th-century Bara Imambara shrine has a huge arched hall. Upstairs, Bhool Bhulaiya is a maze of narrow tunnels with city views from its upper balconies.",
    },
    {
      city_name: "Mumbai",
      rating: "9/10",
      description:
        "Mumbai (formerly called Bombay) is a densely populated city on India’s west coast. A financial center, it's India's largest city. On the Mumbai Harbour waterfront stands the iconic Gateway of India stone arch, built by the British Raj in 1924.",
    },
    {
      city_name: "Bengaluru",
      rating: "9/10",
      description:
        "Bengaluru (also called Bangalore) is the capital of India's southern Karnataka state. The center of India's high-tech industry, the city is also known for its parks and nightlife. Bengaluru is nicknamed the 'Garden City' for its gardens and parks and was once called a Pensioner's Paradise.",
    },
  ],
  Spain: [
    {
      city_name: "Madrid",
      rating: "9/10",
      description:
        "Madrid, Spain's central capital, is a city of elegant boulevards and expansive, manicured parks such as the Buen Retiro. It’s renowned for its rich repositories of European art, including the Prado Museum’s works by Goya, Velázquez and other Spanish masters.",
    },
    {
      city_name: "Barcelona",
      rating: "9/10",
      description:
        "Barcelona, the cosmopolitan capital of Spain’s Catalonia region, is known for its art and architecture. The fantastical Sagrada Família church and other modernist landmarks designed by Antoni Gaudí dot the city.",
    },
    {
      city_name: "Valencia",
      rating: "7.5/10",
      description:
        "The port city of Valencia lies on Spain’s southeastern coast, where the Turia River meets the Mediterranean Sea. It’s known for its City of Arts and Sciences, with futuristic structures including a planetarium, an oceanarium and an interactive museum.",
    },
    {
      city_name: "Seville",
      rating: "8/10",
      description:
        "Seville is the capital of southern Spain’s Andalusia region. It's famous for flamenco dancing, particularly in its Triana neighborhood. Major landmarks include the ornate Alcázar castle complex, built during the Moorish Almohad dynasty, and the 18th-century Plaza de Toros de la Maestranza bullring.",
    },
  ],
  France: [
    {
      city_name: "Paris",
      rating: "9/10",
      description:
        "Paris, France's capital, is a major European city and a global center for art, fashion, gastronomy and culture. Known as the “City of Light” or the “City of Love,” the streets of Paris overflow with culture, art, beauty, and history.",
    },
    {
      city_name: "Bordeaux",
      rating: "8/10",
      description:
        "Bordeaux, hub of the famed wine-growing region, is a port city on the Garonne River in southwestern France. It’s known for its Gothic.",
    },
    {
      city_name: "Marseille",
      rating: "8.5/10",
      description:
        "Marseille, a port city in southern France, has been a crossroads of immigration and trade since its founding by the Greeks circa 600 B.C. At its heart is the Vieux-Port (Old Port), where fishmongers sell their catch along the boat-lined quay.",
    },
    {
      city_name: "Nice",
      rating: "7.5/10",
      description:
        "The city is nicknamed Nice la Belle (Nissa La Bella in Niçard), which means Nice the Beautiful, which is also the title of the unofficial anthem of Nice, written by Menica Rondelly in 1912.",
    },
  ],
  Italy: [
    {
      city_name: "Rome",
      rating: "9/10",
      description:
        "Rome is the capital city and a special comune of Italy, as well as the capital of the Lazio region. The city has been a major human settlement for almost three millennia. With 2,860,009 residents in 1,285 km², it is also the country's most populated comune.",
    },
    {
      city_name: "Milan",
      rating: "8.5/10",
      description:
        "Milan, a metropolis in Italy's northern Lombardy region, is a global capital of fashion and design. Home to the national stock exchange, it’s a financial hub also known for its high-end restaurants and shops.",
    },
    {
      city_name: "Florence",
      rating: "7.5/10",
      description:
        "Florence, capital of Italy’s Tuscany region, is home to many masterpieces of Renaissance art and architecture. One of its most iconic sights is the Duomo, a cathedral with a terracotta-tiled dome engineered by Brunelleschi and a bell tower by Giotto.",
    },
    {
      city_name: "Venice",
      rating: "8/10",
      description:
        "Venice, the capital of northern Italy’s Veneto region, is built on more than 100 small islands in a lagoon in the Adriatic Sea. It has no roads, just canals – including the Grand Canal thoroughfare – lined with Renaissance and Gothic palaces.",
    },
  ],
};

const DEFAULT_COUNTRY = "India";

export { COUNTRY_DICTIONARY, DEFAULT_COUNTRY };
